











import { Component, Vue, Prop } from 'vue-property-decorator';
import i18n from '@/i18n';
import { GQL_recurringOrderListFragments } from '@/queries/__generated__/recurringOrderListFragments';
import gql from 'graphql-tag';

const CREATE_NEXT_ORDER_FROM_RECURRING_ORDER = gql`
  mutation createNextOrderFromRecurringOrder($recurringOrderId: ID!) {
    createNextOrderFromRecurringOrder(input: { recurringOrderId: $recurringOrderId }) {
      order {
        id
        number
        date
      }
      recurringOrder {
        id
        recurringOrderSetting {
          id
          lastDateCreatedOn
          nextDate
        }
      }
    }
  }
`;

@Component
export default class RecurringOrderCreateNextOrderButton extends Vue {
  @Prop() public recurringOrder!: GQL_recurringOrderListFragments;

  private loading = false;

  get isDisabled() {
    return this.loading ||
      !this.recurringOrder.recurringOrderSetting.active ||
      !this.recurringOrder.recurringOrderSetting.nextDate;
  }

  private createNextOrder() {
    this.loading = true;
    this.$apollo.mutate({
      mutation: CREATE_NEXT_ORDER_FROM_RECURRING_ORDER,
      variables: {
        recurringOrderId: this.recurringOrder.id,
      },
    }).then(({ data }) => {
      const createdRecurringOrder = data?.createNextOrderFromRecurringOrder?.recurringOrder;
      if (createdRecurringOrder) {
        Object.assign(this.recurringOrder.recurringOrderSetting, createdRecurringOrder.recurringOrderSetting);
      }

      const order = data?.createNextOrderFromRecurringOrder?.order;
      if (order) {
        this.$sMessage.success(i18n.t('RecurringOrder.createNextOrderSuccess'));
        return;
      }

      this.$sMessage.error(i18n.t('Message.somethingWentWrong'));
    }).catch(() => {
      this.$sMessage.error(i18n.t('Message.somethingWentWrong'));
    }).finally(() => {
      this.loading = false;
    });
  }
}
